<template>
    <div class="pt-2 pb-4 clearfix" v-if="hasAccess">
        <top-nav-bar goto="/requests/list"></top-nav-bar>

        <div v-if="request">
            <h3 class="text-center" v-text="request.title"></h3>

            <list>
                <list-item>
                    <template slot="icon">
                        <icon :icon="request.icon" :classes="request.color + ' w-6 h-6'"></icon>
                    </template>
                    <template slot="title">Current Status</template>
                    <template slot="sub-title">{{request.status_name}}</template>
                </list-item>
            </list>
            <list>
                <list-item>
                    <template slot="icon">
                        <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Date Created</template>
                    <template slot="sub-title">{{formatDate(request.created_at)}}</template>
                </list-item>
                <list-item v-if="request.created_at !== request.updated_at">
                    <template slot="icon">
                        <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Last Update</template>
                    <template slot="sub-title">{{formatDate(request.updated_at)}}</template>
                </list-item>
                <list-item>
                    <template slot="icon">
                        <icon icon="fas fa-user" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Created by</template>
                    <template slot="sub-title">{{request.employee_user.name}}
                        {{request.employee_user.employee_id?'('+request.employee_user.employee_id+')':''}}
                    </template>
                </list-item>
            </list>
            <list>
                <list-item v-if="request.type === 'buddy-flying' || request.type === 'duty-swap'">
                    <template slot="icon">
                        <icon icon="fas fa-user" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Other crew member</template>
                    <template slot="sub-title">{{request.attached_employee_user.name}}
                        {{request.attached_employee_user.employee_id?'('+request.attached_employee_user.employee_id+')':''}}
                    </template>
                </list-item>
                <list-item v-if="request.type === 'pattern-flying'">
                    <template slot="icon">
                        <icon icon="fas fa-paragraph" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Pattern Type</template>
                    <template slot="sub-title">{{request.pattern_type}}</template>
                </list-item>
                <list-item>
                    <template slot="icon">
                        <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Start Date</template>
                    <template slot="sub-title">{{formatDate(request.start_date)}}</template>
                </list-item>
                <list-item>
                    <template slot="icon">
                        <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">End Date</template>
                    <template slot="sub-title">{{formatDate(request.end_date)}}</template>
                </list-item>
                <list-item>
                    <template slot="icon">
                        <icon icon="fas fa-paragraph" classes="text-blue w-6 h-6"></icon>
                    </template>
                    <template slot="title">Reason for request</template>
                    <template slot="sub-title">
                        <truncate-text :text="request.reason || 'None specified'"></truncate-text>
                    </template>
                </list-item>
            </list>

            <div class="block md:inline-flex md:float-right px-4" v-if="request.can_change">
                <button class="btn btn--colored__red w-full" @click="deleteRequest">
                    <i class="fal fa-trash"></i>
                    Delete Request
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [InteractsWithDates, CanAccessView],
        data() {
            return {
                request: null
            }
        },

        mounted() {
            this.$api('hr').get(`requests/${this.$route.params.request}`)
                .then(({data}) => {
                    this.request = data.data
                })
        },

        methods: {
            deleteRequest() {
                this.$api('hr').delete(`requests/${this.$route.params.request}`)
                    .then(() => {
                        this.$router.push('/requests/list')
                        this.$noty.success('Request successfully deleted');
                    })
            }
        }

    }
</script>
